<template>
  <div class="lWrap">
    <page-header
        v-show="this.$localStorage.get('token') && $route.path !== '/auth' && $route.path !== '/policy' && $route.path !=='/nft/dash'">
    </page-header>
    <router-view/>
  </div>
</template>

<script>
import localStorage from './mixins/localStorage'
import sessionStorage from '@/mixins/sessionStorage';

export default {
  name: "App",
  mixins: [localStorage, sessionStorage],
  created() {
    if (this.$route.path !== '/policy') {
      let token = this.$localStorage.get('token');
      if (token) {
        this.performAutoLogin(token);
        let params = {m_type: 'admin', islist: 1}
        this.$api.$user.getMemberList(params).then(res => res.Data.Result).then(res => {
          if (res.Info.Type === 1) {
            let UserInfo = res.List[0].Member
            let UserAlarm = res.List[0].Alarm
            this.afterLogin({
              mb_id: UserInfo.mb_id,
              mb_no: UserInfo.mb_no,
              mb_name: UserInfo.mb_name,
              mb_hp: UserInfo.mb_hp,
              c_idx: 1,
              g_idx: UserInfo.g_idx,
              token: this.$localStorage.get('token'),
              mb_ad_alarm: UserAlarm.mb_ad_alarm,
              mb_alram: UserAlarm.mb_alram,
              first: false
            });
            if(UserInfo.g_idx ==7){
              this.$router.push('/nft/dash')
            }
          } else {
            this.errorAlert(res.Info.reason);
            return false;
          }
        }, () => {
          this.localLogout();
        })
      } else {
        this.$router.push('/auth');
      }
    }
  },
}
</script>

<style lang="scss">
@import "./assets/scss/ionic.app.scss";
</style>

